import React, { createContext, useContext, useState, useEffect } from "react";
import Cookies from "universal-cookie";
import { API_URLS } from "../../api/apiConfig";
import { postWithAuth, getWithAuth } from "../../api/api";
import { Outlet, useLocation, useNavigate } from "react-router-dom";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const cookies = new Cookies();
  const navigate = useNavigate();

  const [authData, setAuthData] = useState({
    isAuthenticated: false,
    session_token: null,
    user_data: null,
  });

  const login = async (email, password) => {
    try {
      const response = await postWithAuth(API_URLS.AUTH_LOGIN, {
        email,
        password,
      });
      console.log(response);

      if (response.message === "success") {
        if (response.data.session_token) {
          cookies.set("session_token", response.data.session_token, {
            path: "/",
          });
          return { success: true, redirect: null };
        } else if (response.data.session_change_password) {
          return {
            success: true,
            redirect: `/login_change_password/${response.data.session_change_password}`,
          };
        }
      }
      return { success: false, redirect: null };
    } catch (error) {
      console.error("Error al iniciar sesión:", error);
      return { success: false, redirect: null };
    }
  };

  const getSessionUser = async () => {
    try {
      console.log("Call to API User Session");
      const rsp = await getWithAuth(API_URLS.GET_USER_SESSION);
      const user_data = rsp.data;
      const newAuthData = {
        isAuthenticated: true,
        session_token: cookies.get("session_token"),
        user_data: user_data,
      };
      setAuthData(newAuthData);
      return newAuthData;
    } catch (error) {
      navigate("/login");
      console.error("Error al actualizar usuario:", error);
      return false;
    }
  };

  const logout = () => {
    const cookies = new Cookies();

    // borra con el mismo path
    cookies.remove("session_token", { path: "/" });

    // (opcional) intenta variantes por si usaste domain en algún momento
    try {
      cookies.remove("session_token", {
        path: "/",
        domain: window.location.hostname,
      });
      cookies.remove("session_token", {
        path: "/",
        domain: `.${window.location.hostname}`,
      });
    } catch {}

    localStorage.removeItem("session_token"); // por si acaso

    setAuthData({
      isAuthenticated: false,
      session_token: null,
      user_data: null,
    });

    navigate("/login", { replace: true });
  };

  return (
    <AuthContext.Provider
      value={{ authData, setAuthData, login, logout, getSessionUser }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  return useContext(AuthContext);
};
